import React, {useState, useEffect} from "react";
import ProductListed from '../../components/ProductListed';
import throttle from 'lodash.throttle'
import ChartScatter from '../../components/ChartScatter';
import Aside from "../../container/Aside";
import {scrollTo, byProperty} from '../../lib/utils';
import "./Scatter.css";

export default function Scatter (props) {

  const {items, disabledItems, chartProps, toggleProducts, selected, toggleLayer, scrolled} = props;
  const [mounted, setMounted] = useState(false);
  const [chart, setChart] = useState(true);
  const [data, setData] = useState([]);
  const [hover, setHover] = useState();
  const renderChart = () => {
    //if(mounted && chart){
      setChart(false);
      setTimeout(() => {setChart(true);}, 100);
    //}
  }

  useEffect(() => {
    if(!mounted){
      setMounted(true);
      scrollTo();
      window.addEventListener("resize", throttle(renderChart, 700));
    }
    if(items.length){
      const chemistries = items
        .reduce((acc, curr) => [...acc, acc.indexOf(curr.properties[0].value) > -1 ? null : curr.properties[0].value], []).filter(item => item).sort();
      const newData = chemistries.map(chemistry => {
        const xValues = items
          .filter(item => item.properties.some(prop => prop.value === chemistry))
          .map(item => {
            const currProp = item.properties.filter(prop => prop.label === chartProps[0] && typeof prop.value !== "string" && prop.type === "physical")[0];
            return currProp ? currProp.value : null;
          })
          .map(value => !value || value === -1 ? 0 : value);
        const yValues = items
          .filter(item => item.properties.some(prop => prop.value === chemistry))
          .map(item => {
            const currProp = item.properties.filter(prop => prop.label === chartProps[1] && typeof prop.value !== "string" && prop.type === "physical")[0];
            return currProp ? currProp.value : null;
          })
          .map(value => !value || value === -1 ? 0 : value);
        return({
          name: chemistry,
          data: xValues.map((value, index) => [value, yValues[index]])
        });
      });
    // Cetiol Coco Chemistry == 0
      // console.log(items.map(item => item.name), items
      //   .filter(item => item.properties.some(prop => chemistries.indexOf(prop.value) > -1)).map(item => item.name));
      setData(newData);
      renderChart();
    }
  }, [mounted, items, chartProps]);

  useEffect(() => {
    return () => {
      //console.log("cleaned up");
      window.removeEventListener("resize", throttle(renderChart, 700));
    };
  }, []);

  return (
    <section className="view scatter clear">
      <div className="chart">
        {chart && <ChartScatter
          product={hover}
          items={items}
          selected={selected}
          axis={chartProps}
          data={data}
          scrolled={scrolled}
          toggleLayer={() => toggleLayer("scatter")}
        />}
      </div>
      <Aside scrolled={scrolled}>
        <ul>
        {[...items,...disabledItems].sort(byProperty("name")).map((item, index) =>
          <li key={index}>
            <ProductListed
              compact
              data={item}
              onMouseEnter={() => setHover(item)}
              onMouseLeave={() => setHover()}
              selected={selected.indexOf(item.id) > -1}
              toggle={toggleProducts}
            />
          </li>
        )}
        </ul>
      </Aside>
    </section>
  )
}
